import React from "react"
import { Skeleton } from "../ui/skeleton"
import { Card } from "../ui/card"

const LoadingSkeleton = () => {
  return (
    <div className="flex h-screen flex-col md:flex-row">
      <aside className="w-full border-r md:w-[300px]">
        <div className="flex h-full flex-col space-y-4 p-4">
          <Skeleton className="h-20 w-full" />
          <nav className="space-y-2">
            {[...Array(7)].map((_, i) => (
              <Skeleton key={i} className="h-10 w-full" />
            ))}
          </nav>
          <div className="flex h-full flex-col justify-end">
            <Skeleton className="h-10 w-full" />
          </div>
        </div>
      </aside>
      <main className="flex-1 overflow-auto p-4">
        <div className="space-y-4">
          <header className="w-full">
            <Skeleton className="h-10 w-full" />
          </header>
          <Card className="p-6">
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-12">
              {[...Array(84)].map((_, i) => (
                <Skeleton key={i} className="h-10" />
              ))}
            </div>
          </Card>
          <footer className="flex flex-col gap-4 sm:flex-row">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </footer>
        </div>
      </main>
    </div>
  )
}

export default LoadingSkeleton
